module.exports = __webpack_public_path__ + "img/gossip-step2.e284818e.png";